import moment from "moment";
import { SHIFTS } from "@/constants/shifts";

// Šta je hitnije u sortiranju po statusu: nije preuzeo → deo → nije poručio → preuzeo.
export const STATE_RANK = { none: 3, part: 2, off: 1, all: 0 };

/**
 * Korisnici firme (jela iz grupa): redovi radnika sa smenom, poručeno / preuzeto / razlikom i statusom, plus čipovi
 * statusa sa brojevima. Zahteva nasleđen stari tab ReportTabGroupMealsTabEmployees (users, orderUsers, filters).
 * Filtriranje po statusu je u starom tabu (orderStatus), a sortiranje i prikaz u ekranu.
 */
export default {
  computed: {
    isSingleDay() {
      return this.filters.dates.from === this.filters.dates.to;
    },
    /** Čipovi statusa sa brojevima; vrednosti su isti statusi kao u starom izborniku (orderStatus). */
    statusChips() {
      const users = this.orderUsers || [];
      const ordered = users.filter((user) => (user.package_count || 0) > 0);
      const taken = ordered.filter((user) => (user.package_count_picked || 0) > 0).length;
      const counts = [users.length, ordered.length, users.length - ordered.length, taken, ordered.length - taken];
      return [
        { value: 0, label: this.$t("all") },
        { value: 1, label: this.$t("users_ordered") },
        { value: 2, label: this.$t("not_ordered") },
        { value: 4, label: this.$t("users_ordered_taken") },
        { value: 3, label: this.$t("users_ordered_not_taken") },
      ].map((chip, index) => ({ ...chip, count: counts[index] }));
    },
    allRows() {
      return this.users.map((user) => this.toRow(user));
    },
    /** Radnici (redovi) posle pretrage, po imenu. */
    matchedRows() {
      const search = this.filters.search;
      const matched = search
        ? this.customSearch(this.allRows, [{ value: "name" }, { value: "idText" }, { value: "externalCode" }], search)
        : this.allRows;
      return [...matched].sort((a, b) => a.name.localeCompare(b.name));
    },
    emptyText() {
      if (this.filters.search) {
        return this.$t("report_mobile.no_results_for", { search: this.filters.search });
      }
      return this.orderUsers.length ? this.$t("report_mobile.no_workers_in_view") : this.$t("no_employee_report_data");
    },
  },
  methods: {
    /** Red radnika: radnik iz starog taba (users) + stanje narudžbe i preuzimanja. */
    toRow(user) {
      const ordered = user.order_count || 0;
      const taken = user.order_payed || 0;
      const state = ordered <= 0 ? "off" : taken <= 0 ? "none" : taken >= ordered ? "all" : "part";
      const stamp = ordered > 0 && user.order_date ? moment(user.order_date, "DD.MM.YYYY HH:mm") : null;
      const name = [user.name, user.lastname].filter(Boolean).join(" ").trim();
      const row = {
        key: `${user.id}-${user.shift || 0}`,
        id: user.id,
        idText: String(user.id),
        externalCode: user.external_code || "",
        name,
        title: user.external_code ? `${name} · ${user.external_code}` : name,
        initials: [user.name, user.lastname]
          .filter(Boolean)
          .map((part) => part.charAt(0))
          .join(""),
        time: stamp && stamp.isValid() ? stamp.format("DD.MM. HH:mm") : "",
        sortTime: stamp && stamp.isValid() ? stamp.valueOf() : 0,
        ordered,
        taken,
        difference: ordered - taken,
        state,
        stateRank: STATE_RANK[state],
        statusLabel: this.statusLabel(state, taken, ordered),
        source: user,
      };
      SHIFTS.forEach((shift) => {
        row[shift.key] = Number(user[shift.key]) || 0;
      });
      return row;
    },
    statusLabel(state, taken, ordered) {
      if (state === "off") {
        return this.$t("report_desktop.status_not_ordered");
      }
      if (state === "all") {
        return this.$t("report_mobile.status_taken");
      }
      if (state === "part") {
        return this.$t("report_mobile.taken_partly", { taken, total: ordered });
      }
      return this.$t("report_mobile.status_not_taken");
    },
    /** Radnik za mesečni pregled (store: report/selectedEmployee); mesec iz istog izvora kao stari dijalog. */
    toEmployeeContext(row) {
      const company = this.selectedCompany;
      return {
        id: row.id,
        name: this.toLatin(row.source.name),
        lastname: this.toLatin(row.source.lastname),
        fullName: row.name,
        companyId: company?.id,
        companyName: this.toLatin(company?.company || company?.name || ""),
        monthUrl: "/user/food-orders-by-month",
      };
    },
  },
};
